import "core-js/modules/es.string.search";
import baustein from "baustein";
import CountryOverlay from "web/script/components/overlays/country-overlay";
import globalEvents from "web/script/utils/global-events";
import store from "web/redux/store";
import { openSignupOverlay } from "web/redux/ducks/signup-overlay";
var name = "app-pre-header-bar-classic";
var JOIN_SELECTOR = ".".concat(name, "__signup");
var LOGIN_SELECTOR = ".".concat(name, "__login");
var COUNTRY_PICKER_SELECTOR = ".".concat(name, "__country-picker");
var CART_SELECTOR = ".".concat(name, "__burger-inner__glyphs-container__burger-cart");
var CART_HIDDEN_MODIFIER = "".concat(name, "__burger-inner__glyphs-container__burger-cart--hidden");
export default baustein.register(name, {
  defaultOptions: {
    enableCountryPicker: false,
    cartItemCount: 0
  },
  init: function init() {
    this._onCartChange = this._onCartChange.bind(this);
  },
  setupEvents: function setupEvents(add) {
    add("click", JOIN_SELECTOR, this._onSignUpPrompt);
    add("click", LOGIN_SELECTOR, this._onLoginPrompt);

    if (this.options.enableCountryPicker) {
      add("click", COUNTRY_PICKER_SELECTOR, this._onCountryPickerClick);
    }
  },
  onInsert: function onInsert() {
    globalEvents.on("cart.change", this._onCartChange);
  },

  /**
   * When the component is removed we can release all global handlers that may have been set.
   */
  onRemove: function onRemove() {
    this.releaseAllGlobalHandlers();
  },

  /**
   * Handler for click events on the country picker menu.
   *
   * @param {Event} event
   */
  _onCountryPickerClick: function _onCountryPickerClick(event) {
    event.stopPropagation();
    event.preventDefault();
    var countryOverlay = new CountryOverlay();
    countryOverlay.appendTo(document.body);
    countryOverlay.open();
  },

  /**
   * Handler for click events on the "sign up" header link.
   */
  _onSignUpPrompt: function _onSignUpPrompt(event) {
    event.preventDefault(); // send it up to the lyst-app to open

    var signupOverlayOptions = {
      path: "/account/register/",
      queryParams: {
        next: [window.location.pathname + window.location.search],
        product_id: [],
        type: ["signup"]
      },
      formType: "signup",
      pageType: "header",
      pageSubType: "signup_or_login"
    };
    store.dispatch(openSignupOverlay(signupOverlayOptions));
  },

  /**
   * Handler for click events on the "sign in" header link.
   */
  _onLoginPrompt: function _onLoginPrompt(event) {
    event.preventDefault(); // send it up to the lyst-app to open

    var signinOverlayOptions = {
      path: "/account/login/",
      queryParams: {
        next: [window.location.pathname + window.location.search],
        product_id: [],
        type: ["sign_in"]
      },
      formType: "sign_in",
      pageType: "header",
      pageSubType: "signup_or_login"
    };
    store.dispatch(openSignupOverlay(signinOverlayOptions));
  },
  _onCartChange: function _onCartChange(event, data) {
    this.options.cartItemCount = this.options.cartItemCount + data.itemCountDifference;
    var cartSelector = this.el.querySelector(CART_SELECTOR);

    if (cartSelector && this.options.cartItemCount > 0 && cartSelector.classList.contains(CART_HIDDEN_MODIFIER)) {
      cartSelector.classList.remove(CART_HIDDEN_MODIFIER);
    }
  }
});